import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useToast } from '../../view/components/ui/use-toast'
import { useEffect, useState } from 'react'
import { reportService } from '../services/reportService'
import { ReportCouponsParams } from '../services/reportService/reportCoupons'
import { startOfMonth, endOfMonth } from 'date-fns'

export const useReportCoupons = () => {
  const [params, setParams] = useState<ReportCouponsParams | undefined>({
    startDate: startOfMonth(new Date()).toISOString(),
    endDate: endOfMonth(new Date()).toISOString(),
  })
  const { isError, isFetching, data, isLoading } = useQuery({
    queryKey: ['reportCoupons', params],
    queryFn: async () => reportService.reportCoupons(params),
    placeholderData: keepPreviousData,
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregador os dados, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    isLoading,
    isFetching,
    data,
    setParams,
    params,
  }
}
